import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Replace with your Stripe publishable key
const stripePromise = loadStripe('pk_test_51SqEQXLARtl4Zx0MUgj6gkPX1netorr1QR5HmEET7xgRuuS56PosxUV3IubuSiglh0wgy9wX1OIfCqWZOHMN9RE800gHf3SYI2');

export default function StripeProvider({ children }) {
    return (
        <Elements stripe={stripePromise}>
            {children}
        </Elements>
    );
}